<div class="row" style="margin-top: 10px;">
  <div class="col-md-12 text-center" *ngIf="loading">
    <img style="width: 30px; padding-left: 2px; margin-top: -3px" src="/img/loading.gif" />
  </div>
  <div class="col-md-12" *ngIf="viewModel$ | async as viewModel">
    <p-table #eventLogTable [value]="viewModel" dataKey="xmlId"
             rowExpandMode="single"
             selectionMode="single"
             [(selection)]="selectedLog"
             tableStyleClass="appointmentLogTable table table-condensed table-fixed-header table-filter header-fixed"
    >
      <ng-template pTemplate="header">

        <tr>
          <th class="th-upper" style="width: 10%">Type</th>
          <th class="th-upper" style="width: 15%">Timestamp</th>
          <th class="th-upper" style="width: 75%;">Message</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-log let-columns="columns"
                   *ngIf="viewModel !== undefined && viewModel.length > 0">
        <tr [pSelectableRow]="log"
            [pRowToggler]="log"
            class="table-row ui-selectable-row"
            [ngClass]="{'selected': log === selectedLog , 'xmlIdSelected' : isXmlIdSelected(log.xmlId)}"
        >
          <td style="vertical-align: middle; font-size: 12px; width: 10%">{{log.type}}</td>
          <td style="vertical-align: middle; font-size: 12px; width: 15%">
            <span *ngIf="selectedTimeZone === 'UTC'">
                {{ log.timestamp |  amUtc |  amDateFormat:'MM/DD/YYYY h:mm a' }}
              </span>

            <span *ngIf="selectedTimeZone !== 'UTC'">
                {{ log.timestamp | amDateFormat:'MM/DD/YYYY h:mm a' }}
              </span>

          </td>
          <td style="vertical-align: middle; font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 75%;">
            <span>{{log.message}}</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-log let-columns="columns">
      <tr class="appointmentLogDetails" style="width: 100%">
        <td colspan="3">
          <input  type="checkbox" [(ngModel)]="lineWrapping" /> Line-wrap
        </td>
      </tr>

      <tr>
        <td colspan="3">
          <ngx-codemirror #codemirror
                          [(ngModel)]="log.message"
                          [options]="getCodeMirrorOptions()"

          ></ngx-codemirror>
        </td>

      </tr>
    </ng-template>
    </p-table>

  </div>
</div>